import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconMove = t0 => {
  const $ = _c(12);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" d="M30.737 2.318a2 2 0 0 1 2.677.138l7.5 7.5.138.151a2 2 0 0 1-2.815 2.815l-.151-.138L32 6.698l-6.086 6.086a2 2 0 1 1-2.828-2.828l7.5-7.5zM38.237 51.068a2 2 0 0 1 2.815 2.815l-.138.151-7.5 7.5a2 2 0 0 1-2.677.138l-.151-.138-7.5-7.5-.138-.151a2 2 0 0 1 2.815-2.815l.151.138L32 57.292l6.086-6.086z" />;
    t4 = <path fill="currentColor" d="M30 60.12V3.87a2 2 0 1 1 4 0v56.25a2 2 0 1 1-4 0M10.112 22.943a2 2 0 0 1 2.815 2.815l-.138.151-6.086 6.086 6.086 6.086.138.151a2 2 0 0 1-2.815 2.815l-.151-.138-7.5-7.5a2 2 0 0 1 0-2.828l7.5-7.5zM51.21 23.08a2 2 0 0 1 2.678-.137l.151.138 7.5 7.5a2 2 0 0 1 0 2.828l-7.5 7.5a2 2 0 1 1-2.828-2.828l6.086-6.086-6.086-6.086-.138-.151a2 2 0 0 1 .138-2.677" />;
    t5 = <path fill="currentColor" d="M60.125 29.995a2 2 0 1 1 0 4H3.875a2 2 0 1 1 0-4z" />;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t6 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}{t4}{t5}</svg>;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
IconMove.displayName = 'IconMove';